export default __webpack_public_path__ + "static/media/canx.90c54687.svg";